import type { ContentfulModule, Cta, DocumentWithEmbeddedEntries } from 'libs/contentful/types';
import type { Colorways, KeyLinePosition, Margins } from 'types/constants';
import type { LinkedIconProps } from 'libs/contentful/types';

export enum CtaAddOnVariant {
  ButtonOnly = 'Button Only',
  Copy = 'Copy',
}

export enum CtaAddOnAlignment {
  Left = 'Left',
  Right = 'Right',
  Centered = 'Centered',
}

export interface CtaAddOnProps extends ContentfulModule {
  headline?: DocumentWithEmbeddedEntries;
  color: Colorways;
  keyLine: KeyLinePosition;
  margins: Margins;
  cta: Cta | LinkedIconProps;
  variant: CtaAddOnVariant;
  alignment?: CtaAddOnAlignment;
  transparentBackground?: boolean;
  pinCtaAboveFold?: boolean;
}
